import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations } from '../translations';

const STORAGE_KEY = 'brundin-lang';
const VALID_LANGS = ['es', 'en', 'ru', 'sv', 'de', 'it', 'pl'];

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && VALID_LANGS.includes(saved)) return saved;
    } catch (_) {}
    return 'es';
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, language);
    } catch (_) {}
  }, [language]);

  const setLanguage = useCallback((lang) => {
    if (VALID_LANGS.includes(lang)) setLanguageState(lang);
  }, []);

  const t = useCallback((key) => {
    const dict = translations[language] || translations.es;
    const keys = key.split('.');
    let value = dict;
    for (const k of keys) {
      value = value?.[k];
    }
    return value != null ? String(value) : key;
  }, [language]);

  const getTranslation = useCallback((key) => {
    const dict = translations[language] || translations.es;
    const keys = key.split('.');
    let value = dict;
    for (const k of keys) {
      value = value?.[k];
    }
    return value;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, getTranslation }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
